// extracted by mini-css-extract-plugin
var _1 = "by-MS5EG";
var _2 = "container-NSZb7";
var _3 = "details-Pva2v";
var _4 = "link-r8RWr";
var _5 = "mid-e6jgu";
var _6 = "out-nA0tK";
var _7 = "preview-teQjg";
var _8 = "price-WiGgl";
var _9 = "stock-CUtFi";
var _a = "title-oRtm8";
var _b = "variants-D1kQy";
export { _1 as "by", _2 as "container", _3 as "details", _4 as "link", _5 as "mid", _6 as "out", _7 as "preview", _8 as "price", _9 as "stock", _a as "title", _b as "variants" }
